export const companiesCompanyIdCompanyRateLimits = "/companies/:company_id/company_rate_limits";
